import { render, staticRenderFns } from "../base/BaseStandardPage.html?vue&type=template&id=36b05de6&external"
import script from "./PtContentPage.vue?vue&type=script&lang=ts"
export * from "./PtContentPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports